import { render } from "./programme1.vue?vue&type=template&id=774e16b0&scoped=true"
import script from "./programme1.vue?vue&type=script&lang=js"
export * from "./programme1.vue?vue&type=script&lang=js"

import "./programme1.vue?vue&type=style&index=0&id=774e16b0&lang=less&scoped=true"

import exportComponent from "D:\\gw\\node_modules\\vue-loader\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-774e16b0"]])

export default __exports__